var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedshiftLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "redshift-logo_svg__katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.7,
    height: 50,
    viewBox: "10 30 125 40",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".redshift-logo_svg__st1{fill:#215c99}.redshift-logo_svg__st2{fill:#5294cf}.redshift-logo_svg__st3{fill:#211c1c}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "redshift-logo_svg__Updated-styles-and-pages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "redshift-logo_svg__Homepage",
    transform: "translate(-1167 -4319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "redshift-logo_svg__Integrations",
    transform: "translate(158 4040)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "redshift-logo_svg__logo-redshift",
    transform: "translate(1009 279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Rectangle",
    fill: "#2e73b8",
    d: "M31.9 32h8.2v41h-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path",
    className: "redshift-logo_svg__st1",
    d: "M31.9 32l-5.7 3.1V70l5.7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_1_",
    className: "redshift-logo_svg__st2",
    d: "M40.2 32v41l5.7-3V35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_2_",
    className: "redshift-logo_svg__st2",
    d: "M51.6 37.7l3.2 1.7v26.2l-3.2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_3_",
    className: "redshift-logo_svg__st1",
    d: "M51.6 67.3l-5.7-1.7V39.4l5.7-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_4_",
    className: "redshift-logo_svg__st1",
    d: "M17.3 39.4v26.2l3.2 1.7V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_5_",
    className: "redshift-logo_svg__st2",
    d: "M20.5 37.7l5.7 1.7v26.2l-5.7 1.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "redshift-logo_svg__Group",
    transform: "translate(44.864 8.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_6_",
    className: "redshift-logo_svg__st3",
    d: "M52.2 34.2v-1.3c0-.2.2-.4.4-.4h6.1c.2 0 .4.1.4.4V34c0 .2-.2.5-.5.9l-3.1 4.5c1.1 0 2.4.2 3.4.8.2.1.3.4.3.6v1.4c0 .2-.2.4-.5.3-1.9-1-4.4-1-6.4 0-.2.1-.5-.1-.5-.3v-1.3c0-.2 0-.6.2-1l3.6-5.2h-3.1c-.1-.1-.3-.3-.3-.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_7_",
    className: "redshift-logo_svg__st3",
    d: "M30 42.7h-1.8c-.2 0-.3-.2-.3-.3v-9.5c0-.2.2-.4.4-.4H30c.2 0 .3.2.4.3V34c.5-1.2 1.3-1.7 2.4-1.7 1.1 0 1.9.6 2.4 1.7.5-1.2 1.4-1.7 2.6-1.7.8 0 1.6.3 2.1 1 .6.8.5 1.9.5 3v6c0 .2-.2.4-.4.4h-1.8c-.2 0-.4-.2-.4-.4v-5.1c0-.4 0-1.4-.1-1.8-.1-.7-.6-.9-1-.9s-1 .3-1.1.8-.2 1.2-.2 1.8v5.1c0 .2-.2.4-.4.4h-1.8c-.2 0-.4-.2-.4-.4v-5.1c0-1 .2-2.6-1.1-2.6s-1.2 1.5-1.2 2.6v5.1c-.1.3-.3.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Shape",
    className: "redshift-logo_svg__st3",
    d: "M64.3 34.3c-1.3 0-1.4 1.8-1.4 3.1 0 1.1 0 3.6 1.4 3.6s1.5-2 1.5-3.2c0-.8 0-1.7-.3-2.5-.2-.8-.6-1-1.2-1m-.1-2c2.8 0 4.2 2.4 4.2 5.3s-1.6 5.2-4.2 5.2c-2.7 0-4.2-2.4-4.2-5.3.1-2.8 1.5-5.2 4.2-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_8_",
    className: "redshift-logo_svg__st3",
    d: "M72 42.7h-1.8c-.2 0-.4-.2-.4-.4v-9.5c0-.2.2-.3.4-.3h1.7c.2 0 .3.1.3.3v1.4c.5-1.3 1.2-1.9 2.5-1.9.9 0 1.6.3 2.2 1.1.5.8.5 2 .5 3v6c0 .2-.2.3-.4.3h-1.8c-.2 0-.3-.1-.3-.3v-5.2c0-1 .1-2.6-1.1-2.6-.5 0-.9.3-1.1.8-.3.6-.3 1.1-.3 1.8v5.2c0 .1-.2.3-.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Shape_1_",
    className: "redshift-logo_svg__st3",
    d: "M47 40.1c-.3.5-.8.9-1.2.9-.7 0-1.1-.6-1.1-1.3 0-1.6 1.4-1.9 2.8-1.9v.4c-.1.7-.1 1.2-.5 1.9m3.7.9c-.4-.5-.7-.9-.7-1.7v-2.9c0-1.2.1-2.4-.9-3.2-.7-.7-1.9-1-2.8-1-1.7 0-3.7.7-4.1 2.9 0 .2.1.4.3.4l1.8.2c.2 0 .3-.2.3-.4.2-.8.8-1.1 1.5-1.1.4 0 .9.1 1 .5.3.4.2.9.2 1.3v.2c-1.1.1-2.5.2-3.5.7-1.1.5-2 1.5-2 3.1 0 1.9 1.2 2.9 2.8 2.9 1.3 0 2-.3 3.1-1.3.4.5.5.8 1 1.2.1.1.3.1.5 0 .4-.3 1-1 1.4-1.2.2-.2.2-.5.1-.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Shape_2_",
    className: "redshift-logo_svg__st3",
    d: "M22.8 40.1c-.3.5-.8.9-1.3.9-.7 0-1.1-.6-1.1-1.3 0-1.6 1.4-1.9 2.8-1.9v.4c-.1.7 0 1.2-.4 1.9m2.9-.8v-2.9c0-1.2.1-2.4-.9-3.2-.8-.7-1.9-1-2.8-1-1.7 0-3.7.7-4.1 2.9 0 .2.1.4.3.4l1.8.2c.2 0 .3-.2.3-.4.2-.8.8-1.1 1.5-1.1.4 0 .9.1 1.1.5.3.4.2.9.2 1.3v.2c-1 .1-2.5.2-3.5.7-1.1.5-2 1.5-2 3.1 0 1.9 1.2 2.9 2.8 2.9 1.3 0 2-.3 3.1-1.3.4.5.5.8 1.1 1.2.1.1.3.1.5 0 .4-.3 1-1 1.4-1.2.2-.1.1-.3 0-.5-.5-.6-.8-1-.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Shape_3_",
    className: "redshift-logo_svg__st3",
    d: "M18.8 50.8h1.1c1.2 0 2-.7 2-1.7 0-1.1-.9-1.6-2.1-1.7-.6 0-1 .1-1.1.1l.1 3.3zm-1.2-4.1c.6-.1 1.4-.2 2.2-.2 1.2 0 2 .2 2.6.8.5.4.7 1 .7 1.7 0 1.1-.8 2-1.7 2.3.7.3 1.1.9 1.3 1.8.3 1.2.5 2.1.7 2.5h-1.2c-.2-.3-.4-1-.6-2.2-.3-1.2-.8-1.7-1.8-1.7h-1.1v3.9h-1.1v-8.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_9_",
    className: "redshift-logo_svg__st3",
    d: "M75.3 60h-3.5v3.2h3.9v1h-5.1v-9h4.9v1h-3.7V59h3.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "redshift-logo_svg__Group_1_",
    transform: "translate(60.136 22.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Shape_4_",
    className: "redshift-logo_svg__st3",
    d: "M19.2 40.4c.3.1.8.1 1.1.1 2.5 0 3.8-1.4 3.8-3.8 0-2.1-1.1-3.4-3.6-3.4-.6 0-1 .1-1.3.1v7zm-1.2-8c.7-.1 1.5-.2 2.5-.2 1.7 0 2.9.4 3.6 1.1.8.8 1.2 1.8 1.2 3.2 0 1.4-.5 2.7-1.3 3.5-.9.9-2.2 1.3-4 1.3-.9 0-1.5 0-2.1-.1l.1-8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_10_",
    className: "redshift-logo_svg__st3",
    d: "M27.6 39.9c.5.3 1.2.6 2.1.6 1.1 0 1.9-.7 1.9-1.5s-.5-1.3-1.7-1.8c-1.4-.5-2.4-1.2-2.4-2.6 0-1.4 1.1-2.5 3-2.5 1 0 1.6.2 2 .5l-.3 1c-.3-.2-.9-.4-1.7-.4-1.2 0-1.7.8-1.7 1.3 0 .9.6 1.2 1.8 1.7 1.5.6 2.3 1.3 2.3 2.7 0 1.4-1 2.6-3.1 2.6-.9 0-1.8-.3-2.3-.6l.1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_11_",
    className: "redshift-logo_svg__st3",
    d: "M96.7 55.2V59h4.4v-3.8h1.1v9h-1.1V60h-4.4v4.2h-1.2v-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Rectangle_1_",
    className: "redshift-logo_svg__st3",
    d: "M105.2 55.2h1.1v9h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_12_",
    className: "redshift-logo_svg__st3",
    d: "M109.3 55.2h4.8v1h-3.7v3h3.4v1h-3.4v4h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redshift-logo_svg__Path_13_",
    className: "redshift-logo_svg__st3",
    d: "M115.7 55.2v1h2.7v8h1.2v-8h2.7v-1z"
  })))))));
}

export default __webpack_public_path__ + "01d79639372fdd3b057a08c6f2a06607.svg";
export { SvgRedshiftLogo as ReactComponent };